import {UI} from "../../../stem-core/ui/UIBase";
import {StyleSheet, styleRule, registerStyle} from "../../../stem-core/ui/Style";

import {ChooseMerchantCard} from "./MerchantSelectInput.jsx";
import {merchantService} from "../../misc/MerchantService";
import {LoadingSpinner} from "../../../core/ui/LoadingSpinner.jsx";

export class ChooseMerchantPageStyle extends StyleSheet {
    @styleRule
    container = {
        display: "flex",
        justifyContent: "center"
    }
}

@registerStyle(ChooseMerchantPageStyle)
export class ChooseMerchantPage extends UI.Element {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            title: "Choose your merchant",
        };
    }

    render() {
        if (!merchantService.isMerchantDataRequestFinished()) {
            return [
                <div>
                    <LoadingSpinner />
                </div>,
            ];
        }

        return <ChooseMerchantCard />;
    }
}
